import { successColor, hexToRgb } from 'assets/jss/material-dashboard-pro-react';

const changePasswordDialog = (theme) => ({
	passwordRules: {
		marginTop: '20px',
	},
	footer: {
		justifyContent: 'center !important',
		display: 'block',
		textAlign: 'center',
		marginBottom: 178,
		marginTop: 7,
	},
	cardBody: ({ isNewDashBoardEnabled }) => ({
		marginTop: isNewDashBoardEnabled ? 0 : 8,
		padding: isNewDashBoardEnabled ? '16px 40px' : '20px 60px',
		[theme.breakpoints.down('xs')]: {
			padding: '20px 30px',
		},
	}),
	buttonContainer: {
		textAlign: 'center',
		marginTop: 49,
	},
	successBox: {
		padding: '16px 24px',
		borderRadius: 8,
		border: `solid 1px ${successColor[0]}`,
		backgroundColor: `rgba(${hexToRgb(successColor[0])}, 0.06)`,
		marginBottom: 41,
		marginTop: 24,
	},
	email: {
		fontWeight: 'bold',
	},
	iconContainer: {
		textAlign: 'center',
	},
	loginUnsuccessful: {
		marginBottom: 18,
	},
	modalSubtitle: ({ isNewDashBoardEnabled }) => ({
		margin: isNewDashBoardEnabled ? '0 -24px 40px' : '0 0 10px',
	}),
	countryCode: {
		height: '100%',
		padding: '0 0.5rem',
		margin: 0,
	},
	otpWrapper: ({ isNewDashBoardEnabled }) => ({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		marginBottom: isNewDashBoardEnabled ? '2.5rem' : 0,
	}),
});

export default changePasswordDialog;
